import React from "react";
import Image from "next/image";

export type Variant = "green" | "blue";

export interface TechnologyTileItem {
  id: number | string;
  title: string;
  iconUrl: string;
}

type Context = "servicesInner" | "servicesPage";

interface TechnologyTilesProps {
  items: TechnologyTileItem[];
  variant?: Variant;
  context?: Context; // controls default hover bg asset path

  // Layout class overrides to allow reuse across pages
  gridClassName?: string;
  tileContainerClasses?: string;
  titleClassName?: string;
  iconWrapperClassName?: string;
  iconImageClassName?: string;
  innerWrapperClassName?: string;
  overlayExtraClassName?: string; // e.g. CSS module hook for hover effects
}

const TechnologyTiles: React.FC<TechnologyTilesProps> = ({
  items,
  variant = "blue",
  context = "servicesInner",
  gridClassName = "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 p-4",
  tileContainerClasses = "xl:aspect-[178_/_133] lg:aspect-[164_/_133] aspect-[164_/_133] w-auto flex items-center justify-center relative bg-white border group",
  titleClassName = "text-start text-subtitle-1 font-regular w-full text-secondary-text px-[15px] pt-[15px]",
  iconWrapperClassName = "absolute bottom-0 right-0 w-fit items-center justify-end px-2.5 pb-2.5",
  iconImageClassName = "object-contain",
  innerWrapperClassName = "",
  overlayExtraClassName = "",
}) => {
  const overlayImageClass =
    context === "servicesPage"
      ? variant === "green"
        ? "bg-[url(/images/ServicesPage/green-hover.jpg)]"
        : "bg-[url(/images/ServicesPage/blue-hover.jpg)]"
      : variant === "green"
        ? "bg-[url(/images/ServicesInner/green-hover.png)]"
        : "bg-[url(/images/ServicesInner/blue-hover.png)]";

  return (
    <div className={gridClassName}>
      {items.map((item) => (
        <div key={item.id} className={tileContainerClasses}>
          <div
            className={`absolute top-0 right-0 w-full h-full bg-cover bg-center bg-no-repeat ${overlayImageClass} opacity-0 transition-all duration-300 group-hover:opacity-100 ${overlayExtraClassName}`}
          />

          <div
            className={`relative z-10 w-full h-full flex flex-col justify-between ${innerWrapperClassName}`}
          >
            <p className={titleClassName}>{item.title}</p>

            <div className={iconWrapperClassName}>
              <Image
                src={item?.iconUrl}
                alt={item.title || "Technology"}
                width={48}
                height={48}
                className={iconImageClassName}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TechnologyTiles;
